/* eslint-disable no-use-before-define */
import React, { useRef } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import KenTextLabel from '../KenTextLabel/index';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > * + *': {
      marginTop: theme.spacing(0),
    },
  },
}));

export default function KenAutoComplete(props) {
  const classes = useStyles();
  console.log('ken', props.name)
  return (
    <div className={classes.root}>
      <KenTextLabel label={props.label} required={props.required} />
      <Autocomplete
        multiple
        limitTags={2}
        ref={props.ref}
        name={props.name}
        id="multiple-limit-tags"
        options={props.options}

        onChange={props.onChange}
        getOptionLabel={(option) => option.title}
        renderInput={(params) => {
          console.log('kenparams', params)
          return <TextField
            name="duration"
            {...params}
            variant={props.variant}
            placeholder={props.placeholder}
          />
        }}
      />
    </div>
  );
}
